import { isEmpty } from 'lodash';
import API from '../index';

const Review = {};
const baseURL = process.env.ODRS_URL || 'http://localhost:3002/';
const api_key = process.env.ODRS_API_KEY;

Review.getReviews = async (resource, reviewCount) => {
  const params = {
    api_key: api_key,
    order: 'id_desc',
    per_page: reviewCount
  };
  let url;
  if (resource.resource_type === 'Opportunity') {
    url = `/v1/organizations/${resource?.organization?.id}/opportunities/${resource.id}/comments`;
  } else if (resource.resource_type === 'Organization') {
    url = `/v1/organizations/${resource.id}/comments`;
  }
  try {
    const response = await API.get(url, params, { api_key, baseURL });
    return response;
  } catch (error) {
    throw error;
  }
};

Review.getRating = async (userId, resource, locale) => {
  const url = '/v1/organizations/' + resource.id + '/ratings/overall';
  const params = {};
  params.locale = locale;
  params.rated_by_type = 'User';
  params.client_rated_by_id = userId;

  try {
    const response = await API.get(url, params, { api_key, baseURL });
    return response;
  } catch (error) {
    throw error;
  }
};

Review.getUserReview = async (userId, resource, locale) => {
  let url;
  const params = {
    locale: locale,
    commented_by_type: 'User',
    client_commented_by_id: userId
  };

  if (resource.resource_type === 'Opportunity') {
    url = `/v1/organizations/${resource?.organization?.id}/opportunities/${resource.id}/comments/${userId}`;
  } else {
    url = `/v1/organizations/${resource.id}/comments/${userId}`;
  }
  try {
    const response = await API.get(url, params, { api_key, baseURL });
    if (isEmpty(response)) {
      throw 'Empty response';
    } else {
      return response;
    }
  } catch (error) {
    throw error;
  }
};

export default Review;
